import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

const MasterChart = ({ masterData, dataKey, titleKey, label, color = "#8884d8", barSize,  }) => {

  const data = Array.isArray(masterData)
    ? masterData.map(item => ({
      name: item[titleKey] || 'N/A',
      value: item[dataKey]
    }))
    : [];

  // Custom Tooltip component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{ backgroundColor: 'white', padding: '10px' }}>
          <p>{titleKey}:  {label}</p>
          <p> Count: {payload[0].value}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
        barCategoryGap="25%"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" label={{ value: titleKey, position: 'bottom', dy: 20 }} />
        <YAxis
          label={{
            value: label,
            angle: -90,
            position: 'insideLeft',
            style: {
              textAnchor: 'middle',
              dominantBaseline: 'middle'
            },
            offset: 0,
            dy: 0,
            dx: -10
          }}
        />
        {/* Use custom tooltip */}
        <Tooltip content={<CustomTooltip />} />
        {/* <Legend /> */}
        <Bar
          dataKey="value"
          name={label}
          fill={color}
          barSize={barSize}
          radius={[5,5,0,0]}
        />
        
      </BarChart>
    </ResponsiveContainer>
  );
};

MasterChart.propTypes = {
  masterData: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataKey: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default MasterChart;
